import { ROLES } from 'lib'

const arrRoles = Object.keys(ROLES).map(v => ROLES[v])

export const MenuDirectory = [
  {
    label: 'Dashboard',
    items: [
      {
        parent: false,
        label: 'Dashboard',
        path: '/dashboard',
        icon: 'MdOutlineSpaceDashboard',
        roles: [...arrRoles]
      }
    ]
  },
  {
    label: 'Customer',
    items: [
      {
        parent: false,
        label: 'Customers',
        path: '/customers',
        icon: 'MdOutlineContacts',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser]
      }
    ]
  },
  {
    label: 'Opportunities',
    items: [
      {
        parent: false,
        label: 'Opportunities',
        path: '/opportunities',
        icon: 'MdList',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser]
      }
    ]
  },
  {
    label: 'Artwork Requests',
    items: [
      {
        parent: false,
        label: 'Artwork Request',
        path: '/artwork-requests/add',
        icon: 'MdAdd',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser, ROLES.ProjectManager]
      },
      {
        parent: false,
        label: 'Artwork Queue',
        path: '/artwork-requests/queue',
        icon: 'MdList',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser, ROLES.ProjectManager, ROLES.GraphicDesigner, ROLES.SeniorGraphicDesigner]
      }
    ]
  },
  {
    label: 'Quotes',
    items: [
      {
        parent: false,
        label: 'Standard Quotes',
        path: '/quotes/edge-quotes',
        icon: 'MdOutlineDocumentScanner',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser, ROLES.ProjectManager]
      },
      {
        parent: false,
        label: 'Ad-Hoc Quotes',
        path: '/quotes/adhoc-quotes',
        icon: 'MdOutlineDocumentScanner',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser, ROLES.ProjectManager]
      }
    ]
  },
  {
    label: 'Map',
    items: [
      {
        parent: false,
        label: 'Map',
        path: '/map',
        icon: 'MdOutlineMap',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser, ROLES.ProjectManager, ROLES.DirectorOfProjectManagement]
      }
    ]
  },
  {
    label: 'Projects',
    items: [
      {
        parent: false,
        label: 'Customer Report',
        path: '/projects/customer-report',
        icon: 'MdOutlineReport',
        roles: [ROLES.Admin]
      },
      {
        parent: false,
        label: 'Team Task Report',
        path: '/projects/team-task-report',
        icon: 'MdOutlineReport',
        roles: [ROLES.Admin]
      },
      {
        parent: false,
        label: 'My Tasks',
        path: '/projects/my-tasks',
        icon: 'MdOutlineTask',
        roles: arrRoles.filter(v => v !== ROLES.GraphicDesigner && v !== ROLES.SeniorGraphicDesigner)
      },
      {
        parent: true,
        label: 'Task Templates',
        icon: 'MdOutlineReport',
        path: '/projects/task-templates',
        items: [
          {
            label: 'General',
            path: '/projects/task-templates/general',
            roles: [ROLES.Admin]
          },
          {
            label: 'Client',
            path: '/projects/task-templates/client',
            roles: [ROLES.Admin]
          }
        ]
      },
      {
        parent: false,
        label: 'Legacy Import',
        path: '/projects/legacy-import',
        icon: 'MdOutlineUploadFile',
        roles: [ROLES.Admin, ROLES.SuperUser]
      },
      {
        parent: false,
        label: 'All Projects',
        path: '/projects',
        icon: 'MdOutlineList',
        roles: arrRoles.filter(v => (v !== ROLES.SalesUser && v !== ROLES.ClientUser && v !== ROLES.GraphicDesigner && v !== ROLES.SeniorGraphicDesigner))
      },
      {
        parent: false,
        label: 'My Projects',
        path: '/projects/me',
        icon: 'MdOutlineList',
        roles: [ROLES.SalesUser, ROLES.ClientUser]
      }
    ]
  },
  {
    label: 'Sales',
    items: [
      {
        parent: false,
        label: 'Commission',
        path: '/sales/commission',
        icon: 'MdAttachMoney',
        roles: [ROLES.Admin]
      },
      {
        parent: false,
        label: 'My Commission',
        path: '/sales/my-commission',
        icon: 'MdAttachMoney',
        roles: [ROLES.SalesManager, ROLES.SalesUser]
      },
      {
        parent: false,
        label: 'Overage',
        path: '/sales/overage',
        icon: 'MdAttachMoney',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser]
      },
      {
        parent: false,
        label: 'Report History',
        path: '/sales/report-history',
        icon: 'MdOutlineHistory',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.SalesUser]
      }
    ]
  },
  {
    label: 'Reporting',
    items: [
      {
        parent: false,
        label: 'Metrics',
        path: '/reporting/metrics',
        icon: 'MdAttachMoney',
        roles: arrRoles.filter(v => (v !== ROLES.SalesUser && ROLES.ClientUser && ROLES.GraphicDesigner))
      }
      // {
      //   parent: false,
      //   label: 'Permit',
      //   path: '/reporting/permit',
      //   icon: 'MdAttachMoney'
      // },
      // {
      //   parent: false,
      //   label: 'Installer',
      //   path: '/reporting/installer',
      //   icon: 'MdAttachMoney'
      // },
      // {
      //   parent: false,
      //   label: 'CPM',
      //   path: '/reporting/cpm',
      //   icon: 'MdAttachMoney'
      // },
      // {
      //   parent: false,
      //   label: 'EMC',
      //   path: '/reporting/emc',
      //   icon: 'MdAttachMoney'
      // },
      // {
      //   parent: false,
      //   label: 'Fabrication',
      //   path: '/reporting/fabrication',
      //   icon: 'MdAttachMoney'
      // },
      // {
      //   parent: false,
      //   label: 'Sales',
      //   path: '/reporting/sales',
      //   icon: 'MdAttachMoney'
      // }
    ]
  },
  {
    label: 'System',
    items: [
      {
        parent: false,
        label: 'User Management',
        path: '/system/users',
        icon: 'MdPeopleOutline',
        roles: [ROLES.Admin, ROLES.SalesManager, ROLES.DirectorOfProjectManagement]
      },
      {
        parent: true,
        label: 'System Options',
        icon: 'MdOutlineSettings',
        path: '/system',
        items: [
          // {
          //   label: 'Mass re-assign task',
          //   path: '/system/massreassign',
          //   roles: [ROLES.Admin]
          // },
          // {
          //   label: 'Task upload',
          //   path: '/system/taskupload',
          //   roles: [ROLES.Admin]
          // },
          {
            label: 'Shipping options',
            path: '/system/shipping-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Existing sign options',
            path: '/system/existing-sign-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Installation options',
            path: '/system/installation-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Site survey options',
            path: '/system/site-survey-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Communication options',
            path: '/system/communication-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Pedestal decoration options',
            path: '/system/pedestal-decoration-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Cabinet toppers options',
            path: '/system/cabinet-topper-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Vertical support options',
            path: '/system/vertical-support-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Engineering table',
            path: '/system/vertical-support-engineering',
            roles: [ROLES.Admin]
          },
          {
            label: 'Footer style options',
            path: '/system/footer-style-options',
            roles: [ROLES.Admin]
          },
          {
            label: 'Terms & Conditions',
            path: '/system/terms',
            roles: [ROLES.Admin]
          },
          {
            label: 'Display Pricings',
            path: '/system/display-pricings',
            roles: [ROLES.Admin]
          },
          {
            label: 'Display Pricings Config',
            path: '/system/display-pricings-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'Survey Email Automations',
            path: '/system/survey-emails-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'Backwrap & Side Vent Pricing',
            path: '/system/backwrap-sidevent-pricing-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'Lightbox / ID Cabinet Pricing',
            path: '/system/cabinet-pricing-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'Pedestal Pricing',
            path: '/system/pedestal-pricing-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'Mow Curb Pricing',
            path: '/system/mow-curb-pricing-config',
            roles: [ROLES.Admin]
          },
          {
            label: 'EMC Vendors',
            path: '/system/emc-vendors',
            roles: [ROLES.Admin, ROLES.ProjectManager]
          },
          {
            label: 'Fabrication Vendors',
            path: '/system/fabrication-vendors',
            roles: [ROLES.Admin, ROLES.ProjectManager]
          },
          {
            label: 'Installation Vendors',
            path: '/system/installation-vendors',
            roles: [ROLES.Admin, ROLES.ProjectManager]
          },
          {
            label: 'Shipping Vendors',
            path: '/system/shipping-vendors',
            roles: [ROLES.Admin, ROLES.ProjectManager]
          },
          {
            label: 'Installer Client Installation',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'Installer Other Options',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'COI Manager',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'Signed POC Manager',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'W9 Manager',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'Issues Pending Manager',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          },
          {
            label: 'Post Install Call Manager',
            path: '/system/vendors/shipping',
            roles: [ROLES.Admin]
          }
        ]
      }
    ]
  }
]
